import "../styles/risk.css";

export default function ClassificationPanel({ risk }) {
  if (!risk || Object.keys(risk).length === 0) return <p className="empty">No risk data available</p>;

  const {
    classification = "Unclassified",
    riskLevel = "unknown",
    compliance = {},
    reasons = [],
    recommendations = []
  } = risk;

  return (
    <div className="risk-modern">

      {/* HEADER */}
      <div className="risk-header">
        <div>
          <h2>Risk & Compliance</h2>
          <p className="muted">Transport risk assessment overview</p>
        </div>

        <span className={`risk-badge ${riskLevel}`} aria-label={`Risk level ${riskLevel}`}>
          {riskLevel.toUpperCase()}
        </span>
      </div>

      {/* CLASSIFICATION */}
      <div className="risk-section">
        <h4>Load Classification</h4>
        <div className="classification-box">
          {classification}
        </div>
      </div>

      {/* COMPLIANCE GRID */}
      <div className="risk-section">
        <h4>Compliance Requirements</h4>

        <div className="risk-grid">

          <div className="risk-box">
            <span>Permit</span>
            <strong>
              {compliance.requiresPermit ? "Required" : "Not Required"}
            </strong>
          </div>

          <div className="risk-box">
            <span>Escort Vehicles</span>
            <strong>{compliance.escorts || 0}</strong>
          </div>

          <div className="risk-box">
            <span>Police Escort</span>
            <strong>
              {compliance.policeEscort ? "Yes" : "No"}
            </strong>
          </div>

        </div>
      </div>

      {/* REASONS */}
      <div className="risk-section">
        <h4>Risk Factors</h4>

        {reasons.length > 0 ? (
          <ul className="risk-list">
            {reasons.map((r, i) => (
              <li key={i}>{r}</li>
            ))}
          </ul>
        ) : (
          <p className="muted">No major risk factors identified</p>
        )}
      </div>

      {/* RECOMMENDATIONS */}
      <div className="risk-section">
        <h4>Operational Recommendations</h4>

        {recommendations.length > 0 ? (
          <ul className="risk-list highlight">
            {recommendations.map((r, i) => (
              <li key={i}>{r}</li>
            ))}
          </ul>
        ) : (
          <p className="muted">No special recommendations</p>
        )}
      </div>

      {/* FOOTER */}
      <div className="risk-footer">
        <p>
          This assessment is based on South African abnormal load regulations
          (TRH11, National Road Traffic Act, SANRAL guidelines).
        </p>
      </div>

    </div>
  );
}